import './Team.css'
import { useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import bruno from "../img/Bruno_foto.png";
import sergio from "../img/Sergio_foto.png";
import rafael from "../img/Rafael_foto.jpg";
import andre from "../img/Andre_foto2.png";
import nuno from "../img/Nuno_foto2.png";
import luisa from "../img/Luisa_foto.jpg";
import miguel from "../img/Miguel_foto2.png";
import raquel from "../img/Raquel_foto2.jpg";
import tiago from "../img/Tiago_foto.png";
import rafael2 from "../img/Rafael2_foto.png";
import jorge from "../img/Jorge_Proenca_foto.jpg";
import luis from "../img/Luis_Guerreiro_foto.jpg";
import paulo from "../img/Paulo_Mendes_foto.jpg";
import robbe from "../img/Robbe_foto.jpg";
import wieland from "../img/Wieland_foto.jpg";
import carlos from "../img/carlos_foto.jpg";
import joaoreis from "../img/joao_reis_foto.jpg";
import nunolima from "../img/nuno_lima_foto.jpg";

function Team() {
    return (
        <div className="team-main">
            <Container className='team-container'>
                <h1 className='team-title'>Meet the <b className='blue'>SSHM4Dams Team</b></h1>
                <Row className="member-cards" style={{ justifyContent: "center", paddingBottom: "50px", paddingTop: "30px" }}>

                    <h2 className='team-name'>Project Leaders</h2>
                    <Col xs={12} md={2} className="member-card">
                        <img src={sergio} className="member-photo" />
                        <h3 className='name'>Sérgio Oliveira</h3>
                        <p className='afil'>Senior Researcher &ndash; LNEC </p>
                        <p className='afil'>Researcher in Charge of SSHM4Dams Project </p>
                        <p className='mail'>sbmoliveira@gmail.com</p>
                        <a class="go-corner" href="https://www.linkedin.com/in/s%C3%A9rgio-oliveira-aa119455/">
                            <div class="go-arrow">
                                →
                            </div>
                        </a>
                    </Col>
                    <Col xs={12} md={2} className="member-card">
                        <img src={jorge} className="member-photo" />
                        <h3 className='name'>Jorge Proença</h3>
                        <p className='afil'>Associate Professor &ndash; IST</p>
                        <p className='mail'>jmiguel@civil.ist.utl.pt</p>
                        <a class="go-corner" href="https://fenix.tecnico.ulisboa.pt/homepage/ist12325">
                            <div class="go-arrow">
                                →
                            </div>
                        </a>
                    </Col>
                    <Col xs={12} md={2} className="member-card">
                        <img src={paulo} className="member-photo" />
                        <h3 className='name'>Paulo Mendes</h3>
                        <p className='afil'>Coordinator Professor &ndash; ISEL</p>
                        <p className='mail'>paulo.mendes@isel.pt</p>
                        <a class="go-corner" href="https://www.isel.pt/docentes/paulo-jorge-henriques-mendes">
                            <div class="go-arrow">
                                →
                            </div>
                        </a>
                    </Col>



                    <h2 className='team-name'>Software Development</h2>
                    <Col xs={12} md={2} className="member-card">
                        <img src={raquel} className="member-photo" />
                        <h3 className='name'>Raquel Chin</h3>
                        <p className='afil'>Full Stack Developer</p>
                        <p className='mail'>raquel.o.chin@gmail.com</p>
                        <a class="go-corner" href="https://www.linkedin.com/in/raquelochin/">
                            <div class="go-arrow">
                                →
                            </div>
                        </a>
                    </Col>
                    <Col xs={12} md={2} className="member-card">
                        <img src={rafael2} className="member-photo" />
                        <h3 className='name'>Rafael Domingues</h3>
                        <p className='afil'>Full Stack Developer</p>
                        <a class="go-corner" href="https://www.linkedin.com/in/rafael-domingues-45511b206">
                            <div class="go-arrow">
                                →
                            </div>
                        </a>
                    </Col>
                    <Col xs={12} md={2} className="member-card">
                        <img src={tiago} className="member-photo" />
                        <h3 className='name'>Tiago Cardoso</h3>
                        <p className='afil'>Full Stack Developer</p>
                        <p className='mail'></p>
                    </Col>
                    <Col xs={12} md={2} className="member-card">
                        <img src={bruno} className="member-photo" />
                        <h3 className='name'>Bruno Oliveira</h3>
                        <p className='afil'>Full Stack External Advisor</p>
                        <p className='mail'>olivbruno8@gmail.com</p>
                        <a class="go-corner" href="https://www.linkedin.com/in/bruno-oliveira-78181176">
                            <div class="go-arrow">
                                →
                            </div>
                        </a>
                    </Col>



                    <h2 className='team-name'>Structural Modelling and Seismic Engineering</h2>
                    <Row style={{justifyContent: 'center'}}>
                        <Col xs={12} md={2} className="member-card">
                            <img src={nuno} className="member-photo" />
                            <h3 className='name'>Nuno Azevedo</h3>
                            <p className='afil'>Assistant Researcher</p>
                            <p className='mail'>nazevedo@lnec.pt</p>
                            <a class="go-corner" href="https://www.cienciavitae.pt/portal/en/5F11-D3D0-F26E">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                        <Col xs={12} md={2} className="member-card">
                            <img src={luis} className="member-photo" />
                            <h3 className='name'>Luís Guerreiro</h3>
                            <p className='afil'>Associate Professor</p>
                            <p className='mail'>luis.guerreiro@tecnico.ulisboa.pt</p>
                            <a class="go-corner" href="https://fenix.tecnico.ulisboa.pt/homepage/ist12397">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                        <Col xs={12} md={2} className="member-card">
                            <img src={andre} className="member-photo" />
                            <h3 className='name'>André Alegre</h3>
                            <p className='afil'>Postdoctoral Research Fellow</p>
                            <p className='mail'>andrefalegre92@gmail.com</p>
                            <a class="go-corner" href="https://www.linkedin.com/in/andrefmalegre">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Row>
                    <Row style={{justifyContent: 'center'}}>
                        <Col xs={12} md={2} className="member-card">
                            <img src={luisa} className="member-photo" />
                            <h3 className='name'>Luísa Braga Farinha</h3>
                            <p className='afil'>Assistant Researcher</p>
                            <p className='mail'>lbraga@lnec.pt</p>
                            <a class="go-corner" href="https://www.cienciavitae.pt/portal/5318-A900-38D2">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                        <Col xs={12} md={2} className="member-card">
                            <img src={miguel} className="member-photo" />
                            <h3 className='name'>Miguel Rodrigues</h3>
                            <p className='afil'>Doctoral Research Fellow</p>
                            <p className='mail'>miguel.ads.rodrigues@gmail.com</p>
                            {/* <a class="go-corner" href="#">
                            <div class="go-arrow">
                                →
                            </div>
                        </a> */}
                        </Col>
                        <Col xs={12} md={2} className="member-card">
                            <img src={rafael} className="member-photo" />
                            <h3 className='name'>Rafael Ramos</h3>
                            <p className='afil'>Doctoral Research Fellow</p>
                            <p className='mail'>rafael_manuel_ramos@hotmail.com</p>
                            <a class="go-corner" href="https://www.linkedin.com/in/rafael-manuel-ramos">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Row>



                    <h2 className='team-name'>Monitoring, Instrumentation ,and Data Analysis</h2>
                    <Col xs={12} md={2} className="member-card">
                        <img src={carlos} className="member-photo" />
                        <h3 className='name'>Carlos Santos</h3>
                        <p className='afil'>Senior Researcher</p>
                        <p className='mail'>csantos@lnec.pt</p>
                    </Col>
                    <Col xs={12} md={2} className="member-card">
                        <img src={joaoreis} className="member-photo" />
                        <h3 className='name'>João Reis</h3>
                        <p className='afil'>Assistant Researcher </p>
                        <p className='mail'>jpreis@lnec.pt</p>
                    </Col>
                    <Col xs={12} md={2} className="member-card">
                        <img src={nunolima} className="member-photo" />
                        <h3 className='name'>Nuno Lima</h3>
                        <p className='afil'>Senior Researcher</p>
                        <p className='mail'>jnplima@lnec.pt</p>
                        <a class="go-corner" href="https://www.linkedin.com/in/jose-nuno-lima-44a03218">
                            <div class="go-arrow">
                                →
                            </div>
                        </a>
                    </Col>



                    <h2 className='team-name'>Project Consultants</h2>
                    <Col xs={12} md={2} className="member-card">
                        <img src={wieland} className="member-photo" />
                        <h3 className='name'>Martin Wieland</h3>
                        <p className='afil'>Dam Safety and Earthquake Engineering Expert</p>
                        <p className='afil'>Chairman of the Commitee on Seismic Aspects of Dam Design of ICOLD</p>
                    </Col>
                    <Col xs={12} md={2} className="member-card">
                        <img src={robbe} className="member-photo" />
                        <h3 className='name'>Emmanuel Robbe</h3>
                        <p className='afil'>Concrete Dam Engineering Expert &ndash; EDF-DTG</p>
                        <a class="go-corner" href="https://fr.linkedin.com/in/emmanuel-robbe-1b94692ab">
                            <div class="go-arrow">
                                →
                            </div>
                        </a>
                    </Col>



                </Row>

            </Container>

        </div>
    )
}
export default Team;